import { createFileRoute } from '@tanstack/react-router'
import { requireCapability } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { reportRangeSearchSchema } from '@/features/reports/components/report-range-search'
import { CustomersPage } from '@/features/reports/pages/customers'

import type { ReportRangeSelection } from '@/types'

export const Route = createFileRoute('/_dashboard/analytics/customers')({
  beforeLoad: requireCapability('VIEW_REPORTS'),
  validateSearch: reportRangeSearchSchema,
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: CustomersRoute,
})

function CustomersRoute() {
  const selection = Route.useSearch()
  const navigate = Route.useNavigate()
  const onSelectionChange = (next: ReportRangeSelection) => navigate({ search: next, replace: true })
  return <CustomersPage selection={selection} onSelectionChange={onSelectionChange} />
}
